import { createApp } from 'vue'
import { createHead } from '@unhead/vue'
import * as Sentry from '@sentry/vue'
import App from './App.vue'
import router from './router'
import { i18n, install } from './plugins/i18n'
import { authDirective } from './directives/auth'
import { shouldIgnoreError } from './composables/useSentryHelper'
import pinia from '@/stores'
import '@unocss/reset/tailwind.css'
import './styles/main.less'
import 'uno.css'
import './plugins'
import { initImageOptimization } from '@/utils/imageOptimization'
import { useGoogleAnalytics } from './composables/useGoogleAnalytics'
import './utils/polyfills'
import { initVersionCheck } from './utils/versionCheck'

// 初始化 Google Analytics
useGoogleAnalytics()

// 初始化图片优化
initImageOptimization()

// 初始化版本检查
initVersionCheck()

// 初始化应用
const head = createHead()
const app = createApp(App)
app.directive('auth', authDirective)

//兼容IE11
if (!FileReader.prototype.readAsBinaryString) {
  FileReader.prototype.readAsBinaryString = function (fileData: Blob) {
    let binary = ''
    const pt = this
    const reader = new FileReader()
    reader.onload = function (e: ProgressEvent<FileReader>) {
      const result = e.target?.result
      if (result instanceof ArrayBuffer) {
        const bytes = new Uint8Array(result)
        const length = bytes.byteLength
        for (let i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i])
        }
        // @ts-ignore
        pt.content = binary
        if (pt.onload) {
          pt.onload(e)
        }
      }
    }
    reader.readAsArrayBuffer(fileData)
  }
}

const dsn_type: any = {
  production:
    'https://3b4c876bb96c5233182955f724b0ce63@o4509409631535104.ingest.us.sentry.io/4509409772699648',
  staging:
    'https://40235d806f1b05f97b552f8ba507ce8f@o4509409631535104.ingest.us.sentry.io/4509409652310016',
  development:
    'https://40235d806f1b05f97b552f8ba507ce8f@o4509409631535104.ingest.us.sentry.io/4509409652310016',
}
if (import.meta.env.MODE !== 'development') {
  Sentry.init({
    app,
    dsn: dsn_type[import.meta.env.MODE],
    beforeSend(event, hint) {
      if (shouldIgnoreError(event, hint)) {
        return null
      }
      return event
    },
    sendDefaultPii: true,
    integrations: [Sentry.replayIntegration()],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

// 挂载应用
app.use(router).use(pinia).use(i18n).use(head).mount('#app')
install()
// 注册 Service Worker
if ('serviceWorker' in navigator && 'PushManager' in window) {
  // 使用 setTimeout 延迟注册，避免阻塞页面加载
  setTimeout(() => {
    const registerSW = async () => {
      try {
        await Promise.race([
          navigator.serviceWorker.register('/firebase-messaging-sw.js'),
          new Promise((_, reject) =>
            setTimeout(() => reject(new Error('SW registration timeout')), 5000),
          ),
        ])
      } catch (err) {
        console.warn('Service Worker registration failed:', err)
      }
    }
    registerSW()
  }, 1000)
}
